var map = {
	"./type_1.png": "fdd0",
	"./type_2.png": "ca5f",
	"./type_3.png": "011e",
	"./type_4.png": "66a0",
	"./type_5.png": "bcbf",
	"./type_6.png": "c309",
	"./type_7.png": "a72f",
	"./type_8.png": "e7e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07f6";